"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GrownFromHeritage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223212" id="the-farvision-legacy" className="bg-white text-foreground w-full py-20 lg:py-32 px-6 lg:px-[10%] overflow-hidden">
            <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                {}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 lg:mb-16 gap-6">
                    <h2 className="font-default text-4xl lg:text-5xl font-bold tracking-tight text-[#1A1A1A]">
                        About Us
                    </h2>
                    <Link to="/AboutPage" className="inline-flex items-center justify-center px-8 py-3 bg-primary text-primary-foreground font-default text-sm font-bold uppercase tracking-widest rounded-md transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(114,211,110,0.5)] shadow-md">
                        Learn more
                    </Link>
                </div>

                {}
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-center">
                    {}
                    <div className="relative group lg:col-span-3">
                        <div className="relative rounded-lg overflow-hidden shadow-xl aspect-[4/3] lg:aspect-video">
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/008.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/008.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/008.jpg-wvc-sizes" alt="Farvision factory building exterior" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                        </div>
                        
                        {}
                        <div className="absolute -bottom-6 -right-4 md:-bottom-10 md:-right-8 w-1/2 max-w-[280px] bg-white p-2 rounded-lg shadow-2xl border border-muted">
                            <div className="rounded-md overflow-hidden">
                                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/009.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/009.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/009.png-wvc-sizes" alt="Company quality certificates and awards" className="w-full h-auto object-contain" loading="lazy" />
                            </div>
                        </div>
                    </div>

                    {}
                    <div className="flex flex-col justify-center lg:col-span-2">
                        <div className="space-y-6">
                            <p className="font-default text-lg lg:text-xl leading-relaxed text-[#4B5563]">
                                Farvision (Shenzhen) Intelligent Equipment Co., Ltd. has been focused on the research, development and production of high-precision and high-speed sorting equipment. Currently, we are a leader in domestic markets, with stable product quality and excellent performance.
                            </p>
                            <div className="pt-4 border-t border-muted">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
}